export const SITE_ORIGIN = 'https://www.residentieleo.be';

export type RouteId = 'home' | 'privacy' | 'disclaimer' | 'notfound';

export interface RouteInfo {
  id: RouteId;
  path: string;
  file: string;
  title: string;
  description: string;
  indexable: boolean;
  inSitemap: boolean;
  // Fixed lastmod for the sitemap (and, for home, the JSON-LD dateModified);
  // omitted means "build date". Update it whenever the page's content
  // actually changes — not on every deploy. A date that doesn't track real
  // changes trains Google to distrust it, which defeats the purpose.
  lastmod?: string;
}

export const ROUTES: RouteInfo[] = [
  {
    id: 'home',
    path: '/',
    file: 'index.html',
    title: 'Nieuwbouwwoningen te koop in Grobbendonk | Project LEO',
    description:
      'Project LEO: 8 exclusieve nieuwbouwwoningen te koop in Grobbendonk, tussen de Leopoldstraat en de Floris Primsstraat. 3 eengezinswoningen en 5 appartementen.',
    indexable: true,
    inSitemap: true,
    lastmod: '2026-09-30',
  },
  {
    id: 'privacy',
    path: '/privacy',
    file: 'privacy.html',
    title: 'Privacy- en cookieverklaring | Project LEO',
    description:
      'Lees hoe Project LEO (Blueprint Development) omgaat met je persoonsgegevens en cookies, conform de AVG.',
    indexable: true,
    inSitemap: true,
    lastmod: '2026-10-07',
  },
  {
    id: 'disclaimer',
    path: '/disclaimer',
    file: 'disclaimer.html',
    title: 'Disclaimer | Project LEO',
    description:
      'Disclaimer van residentieleo.be: beelden, oppervlaktes, specificaties en prijzen zijn indicatief en niet bindend.',
    indexable: true,
    inSitemap: true,
    lastmod: '2026-09-30',
  },
  {
    id: 'notfound',
    path: '/404',
    file: '404.html',
    title: 'Pagina niet gevonden | Project LEO',
    description: 'Deze pagina bestaat niet. Ga terug naar de homepage van Project LEO.',
    indexable: false,
    inSitemap: false,
  },
];

export function resolveRoute(pathname: string): RouteInfo {
  let path = pathname.split('?')[0].split('#')[0];
  path = path.replace(/\/index\.html$/, '/').replace(/\.html$/, '');
  if (path.length > 1) path = path.replace(/\/+$/, '');
  if (path === '') path = '/';
  return ROUTES.find((r) => r.path === path) ?? ROUTES.find((r) => r.id === 'notfound')!;
}

export function absoluteUrl(path: string) {
  return SITE_ORIGIN + (path === '/' ? '' : path);
}
